import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import DetailTop from "@/views/consult/components/DetailTop.vue";
import DetailUserInfo from "@/views/consult/components/DetailUserInfo.vue";
import SchematicImg from "@/views/consult/components/SchematicImg.vue";
import MsgList from "@/views/consult/components/MsgList.vue";
import CommonReply from "@/views/consult/components/CommonReply.vue";
import FastReply from "@/views/consult/components/FastReply.vue";
import Close from "@/views/consult/components/Close.vue";
import { mapState } from "vuex";
import util from "@/libs/util";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  name: "details",
  mixins: [userPopMixin],
  components: {
    MsgList: MsgList,
    SchematicImg: SchematicImg,
    DetailUserInfo: DetailUserInfo,
    DetailTop: DetailTop,
    CommonReply: CommonReply,
    FastReply: FastReply,
    Close: Close
  },
  computed: _objectSpread(_objectSpread({}, mapState("d2admin/user")), {}, {
    //是客服角色
    isCustomerService: function isCustomerService() {
      var _this$followList;
      var id = util.cookies.get("uuid");
      return (_this$followList = this.followList) === null || _this$followList === void 0 ? void 0 : _this$followList.find(function (item) {
        return item.id === id;
      });
    },
    showReply: function showReply() {
      var _this$dataSource;
      return ((_this$dataSource = this.dataSource) === null || _this$dataSource === void 0 ? void 0 : _this$dataSource.status) != 3 && this.isCustomerService;
    }
  }),
  data: function data() {
    return {
      dataSource: {},
      risk: {},
      form: {
        content: "",
        imgs: []
      },
      followList: [],
      messageList: [],
      total: 0,
      atPosition: {
        left: 0,
        top: 0,
        keyword: "",
        height: 0,
        show: false
      },
      sending: false,
      welcomeMsg: "",
      userInfo: {}
    };
  },
  watch: {
    "atPosition.show": function atPositionShow(newVal) {
      var _this = this;
      if (newVal) {
        this.$nextTick(function () {
          _this.$refs.fastReply.search(_this.atPosition.keyword);
        });
      }
      var dom = document.querySelector(".d2-container-full__body");
      dom && (dom.style.overflow = newVal ? "hidden" : "auto");
    }
  },
  created: function created() {
    this.getAdvisoryInfo();
    this.getUserBaseInfo();
    this.getFollowList();
  },
  methods: {
    closeFastReply: function closeFastReply() {
      var _this2 = this;
      setTimeout(function () {
        _this2.atPosition.show = false;
      }, 200);
    },
    //快捷回复点击记录
    faqClick: function faqClick(id) {
      this.$api.faqClick({
        questionId: id,
        adminId: util.cookies.get("uuid"),
        advisoryId: this.$route.query.id
      });
    },
    selectAnswer: function selectAnswer(info, id) {
      this.faqClick(id);
      var text = this.form.content;
      var textarea = this.$refs.answerInput.$el.querySelector("textarea");
      var cursorPosition = textarea.selectionStart;

      // 获取光标前的文本
      var textBeforeCursor = text.substring(0, cursorPosition);

      // 在光标前的文本中查找最后一个@符号
      var lastAtIndex = textBeforeCursor.lastIndexOf("@");
      if (lastAtIndex !== -1) {
        // 替换光标前最近的@及其后面的内容，保留光标后的内容
        this.form.content = text.substring(0, lastAtIndex) + info + text.substring(cursorPosition);

        // 设置光标位置到插入内容的末尾
        this.$nextTick(function () {
          var newCursorPosition = lastAtIndex + info.length;
          textarea.setSelectionRange(newCursorPosition, newCursorPosition);
          textarea.focus();
        });
      } else {
        this.form.content += info;
      }
      this.atPosition.show = false;
    },
    handleInput: function handleInput() {
      var _this3 = this;
      var text = this.form.content;
      var textarea = this.$refs.answerInput.$el.querySelector("textarea");
      var cursorPosition = textarea.selectionStart;

      // 获取光标前的文本
      var textBeforeCursor = text.substring(0, cursorPosition);

      // 在光标前的文本中查找最后一个@符号
      var lastAtIndex = textBeforeCursor.lastIndexOf("@");
      if (lastAtIndex === -1) {
        this.atPosition.show = false;
        return;
      }

      // 获取@符号后到光标位置的文本作为关键词
      var keyword = textBeforeCursor.slice(lastAtIndex + 1);

      // 获取输入框位置信息
      var position = this.getAtSymbolPosition(textarea, lastAtIndex);
      this.atPosition = {
        left: position.left,
        top: position.top,
        height: position.height,
        keyword: keyword,
        show: true
      };

      // 触发FastReply组件的搜索
      this.$nextTick(function () {
        _this3.$refs.fastReply.search(keyword);
      });
    },
    getAtSymbolPosition: function getAtSymbolPosition(textarea, atIndex) {
      var textareaRect = textarea.getBoundingClientRect();
      var style = window.getComputedStyle(textarea);
      var lineHeight = parseInt(style.lineHeight) || parseInt(style.height) || 20;
      // 获取@符号之前的文本
      var textBeforeAt = textarea.value.substring(0, atIndex);

      // 创建临时div来计算@的位置
      var div = document.createElement("div");
      div.style.position = "absolute";
      div.style.top = "0";
      div.style.left = "0";
      div.style.visibility = "hidden";
      div.style.whiteSpace = "pre-wrap";
      div.style.wordBreak = "break-all";
      div.style.width = getComputedStyle(textarea).width;
      div.style.font = style.font;
      div.style.fontSize = style.fontSize;
      div.style.lineHeight = style.lineHeight;
      div.style.paddingLeft = style.paddingLeft;
      div.style.paddingRight = style.paddingRight;
      div.style.paddingTop = style.paddingTop;
      div.style.paddingBottom = style.paddingBottom;
      div.style.boxSizing = "border-box";

      // 插入一个特殊标记来定位@的位置
      var markerSpan = '<span id="marker">@</span>';
      div.innerHTML = textBeforeAt.replace(/\n/g, "<br>") + markerSpan;
      document.body.appendChild(div);
      var marker = div.querySelector("#marker");
      var markerRect = marker.getBoundingClientRect();
      var divRect = div.getBoundingClientRect();

      // 计算相对于视口的位置
      var left = textareaRect.left + (markerRect.left - divRect.left);
      var top = textareaRect.top + (markerRect.top - divRect.top);

      // 清理
      document.body.removeChild(div);
      return {
        left: left,
        top: top,
        height: lineHeight
      };
    },
    //发送前判断是否存在其它客服
    hasAnother: function hasAnother() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve, reject) {
                  var res, adminId, followId;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return _this4.$api.getAdvisoryInfo({
                          userId: _this4.$route.query.userId,
                          advisoryId: _this4.$route.query.id
                        });
                      case 1:
                        res = _context.v;
                        adminId = util.cookies.get("uuid");
                        followId = res.data.followId;
                        if (followId === adminId) {
                          resolve(false);
                        } else if (!followId) {
                          resolve(false);
                        } else {
                          resolve(true);
                        }
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee2);
      }))();
    },
    sendReply: function sendReply() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res, bol;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = _objectSpread(_objectSpread({
                advisoryId: _this5.$route.query.id
              }, _this5.form), {}, {
                followId: util.cookies.get("uuid")
              });
              _context3.n = 1;
              return _this5.$api.addReply(params);
            case 1:
              res = _context3.v;
              if (res.data) {
                _this5.$message.success("回复成功");
                _this5.form = {
                  content: "",
                  imgs: []
                };
                if (_this5.dataSource.status == 0) {
                  _this5.addLog("follow");
                  setTimeout(function () {
                    _this5.addLog("reply");
                  }, 300);
                } else {
                  bol = _this5.hasDifferentFollowIds(_this5.dataSource.list);
                  if (bol) {
                    _this5.addLog("reply");
                  }
                }
                _this5.getAdvisoryInfo();
              }
              _this5.sending = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    //回复
    addReply: function addReply() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var hasOther;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (_this6.form.content.trim()) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, _this6.$message.warning("请输入回复内容"));
            case 1:
              _this6.sending = true;
              _context4.n = 2;
              return _this6.hasAnother();
            case 2:
              hasOther = _context4.v;
              if (hasOther) {
                _this6.$confirm("当前咨询已有其他人跟进，是否继续回复?", "是否继续回复", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then(function () {
                  _this6.sendReply();
                }).catch(function () {
                  _this6.sending = false;
                  _this6.getAdvisoryInfo();
                });
              } else {
                _this6.sendReply();
              }
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    addLog: function addLog(text) {
      this.$operationLog.push({
        operationType: "consult",
        code: text,
        detailBatchNo: this.$route.query.id,
        userId: this.$route.query.userId,
        houseCode: this.dataSource.serialNumber
      });
    },
    //判断是否已有客服回复过
    hasDifferentFollowIds: function hasDifferentFollowIds(data) {
      if (data.length < 2) return false;
      var firstId = data[0].followId;
      return data.some(function (item) {
        return item.followId !== firstId;
      });
    },
    getFollowList: function getFollowList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this7.$api.getAdminUser({
                type: "customer_service"
              });
            case 1:
              res = _context5.v;
              _this7.followList = res.data || [];
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    //获取咨询详情包括咨询对话
    getAdvisoryInfo: function getAdvisoryInfo() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _res$data, _this8$dataSource;
        var res, _this8$dataSource2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this8.$api.getAdvisoryInfo({
                userId: _this8.$route.query.userId,
                advisoryId: _this8.$route.query.id
              });
            case 1:
              res = _context6.v;
              res.data && (_this8.dataSource = res.data);
              _this8.userInfo.isRelease = (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.user) === null || _res$data === void 0 ? void 0 : _res$data.isRelease;
              _this8.total = ((_this8$dataSource = _this8.dataSource) === null || _this8$dataSource === void 0 || (_this8$dataSource = _this8$dataSource.list) === null || _this8$dataSource === void 0 ? void 0 : _this8$dataSource.length) || 0;
              if (_this8.dataSource.status === 0) {
                _this8.getAdminUserInfo(((_this8$dataSource2 = _this8.dataSource) === null || _this8$dataSource2 === void 0 || (_this8$dataSource2 = _this8$dataSource2.user) === null || _this8$dataSource2 === void 0 ? void 0 : _this8$dataSource2.name) || "");
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    //获取用户咨询详情
    getAdminUserInfo: function getAdminUserInfo(name) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _res$data2;
        var adminId, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              adminId = util.cookies.get("uuid");
              _context7.n = 1;
              return _this9.$api.getAdminUserInfo(adminId);
            case 1:
              res = _context7.v;
              _this9.welcomeMsg = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.welcomeMsg) || "";
              if (_this9.welcomeMsg) {
                _this9.form.content = _this9.welcomeMsg.replace(/\$\{name\}/g, name);
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    //获取用户基本信息
    getUserBaseInfo: function getUserBaseInfo() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var user;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this0.$api.getUserBaseInfo({
                id: _this0.$route.query.userId
              });
            case 1:
              user = _context8.v;
              _this0.userInfo = _objectSpread(_objectSpread({}, _this0.userInfo), user.data);
              _this0.getUserListByIds([_this0.userInfo], "id");
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  }
};